import {required } from "@vuelidate/validators";
const tlptalep = {
    data() {
      return { 
        tlptalepData:{  
          Olusturanid:null,
          Baslik:null, 
          Aciklama:"", 
          Tahminibitis:null, 
          Taleptipid:null, 
          Atananbirimid:null, 
          Durumid:null,  
          Oncelikid:null, 
          Atananpersonelid:null,   
          Destekoncelikid: null,
          Isgucu: null,
          Harcananzaman: null,
          Ucretli: null,
          Uygulamaid: null , 
          Atanantemsilciid: null,
          Ilid: null,
          Ilceid: null,
          Mahalle: null,
          Adres: null,
        },  
          FormDataType:{ 
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"},
            Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:"Açıklama",FieldType:"text"},
            Tahminibitis:{FieldName:"Tahminibitis",Field:"date",FieldTitle:"Tahmini Bitiş Tarihi"}, 
            Taleptipid:{FieldName:"Taleptipid",Field:"combobox",FieldTitle:"Talep Tipi",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Atananbirimid:{FieldName:"Atananbirimid",Field:"combobox",FieldTitle:"Atanan Birim",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Durumid:{FieldName:"Durumid",Field:"combobox",FieldTitle:"Durum",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Oncelikid:{FieldName:"Oncelikid",Field:"combobox",FieldTitle:"Öncelik",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Atananpersonelid:{FieldName:"Atananpersonelid",Field:"combobox",FieldTitle:"Atanan Personel",ComboData:{},ComboDataArray:[],Multiple:false},  
            Olusturanid:{FieldName:"Olusturanid",Field:"combobox",FieldTitle:"Talep Sahibi",ComboData:{},ComboDataArray:[],Multiple:false},  
            Destekoncelikid:{FieldName:"Destekoncelikid",Field:"combobox",FieldTitle:"Destek Öncelik",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Isgucu:{FieldName:"Isgucu",Field:"input",FieldTitle:"İş Gücü",FieldType:"text"},
            Harcananzaman:{FieldName:"Harcananzaman",Field:"input",FieldTitle:"Harcanan Zaman",FieldType:"text"},
            Ucretli:{FieldName:"Ucretli",Field:"checkbox",FieldTitle:"Ücretli"},  
            Uygulamaid:{FieldName:"Uygulamaid",Field:"combobox",FieldTitle:"Uygulama",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Atanantemsilciid:{FieldName:"Atanantemsilciid",Field:"combobox",FieldTitle:"Atanan Temsilci",ComboData:{},ComboDataArray:[],Multiple:false}, 
               
            Ilid:{FieldName:"Ilid",Field:"combobox",FieldTitle:"İl",ComboData:{},ComboDataArray:[],Multiple:false},  
            Ilceid:{FieldName:"Ilceid",Field:"combobox",FieldTitle:"İlçe",ComboData:{},ComboDataArray:[],Multiple:false}, 
            Mahalle:{FieldName:"Mahalle",Field:"input",FieldTitle:"Mahalle",FieldType:"text"},
            Adres:{FieldName:"Adres",Field:"input",FieldTitle:"Adres",FieldType:"text"},

          }  
      }  
    }, 
    validations:{ 
      FormData: { 
        Baslik: { required }, 
        Aciklama: { required },  
        Tahminibitis: {  },  
        Taleptipid: { required  },  
        Atananbirimid: {  },  
        Durumid: {  },  
        Oncelikid: { required },  
        Atananpersonelid: {  },   
        Destekoncelikid: {},
        Isgucu: {},
        Harcananzaman: {},
        Ucretli: {},
        Uygulamaid:{},
        Atanantemsilciid:{},
        Ilid: {  },  
        Ilceid: {  },  
        Mahalle: {  },  
        Adres: {  },  
      } 
  },
  created(){ 
    this.ActionsFilterGet({ Service: "oililce", FullData: true, Filter: "&Sadeceiller=true" }).then((res) => {
      this.FormDataType.Ilid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        kod: item.Kod,
        label: item.Value
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=8" }).then((res) => {
      this.FormDataType.Uygulamaid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=5" }).then((res) => {
      this.FormDataType.Taleptipid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=4" }).then((res) => {
      this.FormDataType.Durumid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value,
        Kod: item.Kod
      }));
    });
    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=6" }).then((res) => {
      this.FormDataType.Oncelikid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      })); 
      this.FormDataType.Destekoncelikid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));

      
    });

    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Atananbirimid.ComboDataArray = res.Data 
    });

    
    this.ActionsFilterGet({ Service: "opersonel", FullData: true, Filter: "&Birimtip=1" }).then((res) => {
      this.FormDataType.Atananpersonelid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Adsoyad
      })); 
      this.FormDataType.Atanantemsilciid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Adsoyad
      })); 
    });

    this.ActionsFilterGet({ Service: "opersonel", FullData: true, Filter: "" }).then((res) => { 
      this.FormDataType.Olusturanid.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Adsoyad
      }));
      this.FormDataType.Olusturanid.ComboDataArray2 = res.Data.map(item => ({
        id: item.Eposta,
        label: item.Adsoyad
      }));
    });

    

   
  }
}
export default tlptalep